(() => {
  const NORMAL_PRODUCT_HANDLES = new Set(['utsuwa-naire', 'ori-naire']);

  function itemHandle(item) {
    return item?.handle || item?.product_handle || '';
  }

  function errorFromResponse(response) {
    return response?.description || response?.message || response?.errors || '版代をカートに反映できませんでした。';
  }

  async function fetchCart() {
    const response = await fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
    const cart = await response.json();
    if (!response.ok || cart?.status || cart?.errors) throw new Error(errorFromResponse(cart));
    return cart;
  }

  async function updateCart(updates, sections = [], sectionsUrl = window.location.pathname) {
    const body = { updates };
    if (sections.length) {
      body.sections = sections;
      body.sections_url = sectionsUrl;
    }

    const response = await fetch(routes.cart_update_url, {
      ...fetchConfig(),
      body: JSON.stringify(body),
    });
    const cart = await response.json();
    if (!response.ok || cart?.status || cart?.errors) throw new Error(errorFromResponse(cart));
    return cart;
  }

  async function reconcile(cart, sections = [], sectionsUrl = window.location.pathname) {
    const config = window.nairePlateFee || {};
    const variantId = Number(config.variantId || 0);
    const productHandle = config.productHandle || 'naire-plate-fee';

    const currentCart = cart?.items ? cart : await fetchCart();
    const requiresPlateFee = currentCart.items.some((item) => NORMAL_PRODUCT_HANDLES.has(itemHandle(item)));
    const plateFeeLines = currentCart.items.filter(
      (item) => (variantId > 0 && Number(item.variant_id) === variantId) || itemHandle(item) === productHandle
    );
    const totalPlateFeeQuantity = plateFeeLines.reduce((total, item) => total + Number(item.quantity || 0), 0);

    if (requiresPlateFee && plateFeeLines.length === 1 && totalPlateFeeQuantity === 1) return null;
    if (!requiresPlateFee && plateFeeLines.length === 0) return null;
    if (requiresPlateFee && !variantId) throw new Error('版代商品の設定が完了していません。');

    const updates = {};
    if (requiresPlateFee && plateFeeLines.length === 0) {
      updates[variantId] = 1;
    } else if (requiresPlateFee) {
      plateFeeLines.forEach((item, index) => {
        updates[item.key] = index === 0 ? 1 : 0;
      });
    } else {
      plateFeeLines.forEach((item) => {
        updates[item.key] = 0;
      });
    }

    return updateCart(updates, sections, sectionsUrl);
  }

  window.NaireCart = { fetchCart, reconcile };
})();
